/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductsCategorySection.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
******************************************************************************/
import React from 'react';
import { connect } from 'react-redux';
import { SelectComponentProps } from '../../../../types/index';
import CategoryActions from '../../redux/actions/product-listing-actions';
import { SelectCategoryValue } from '..';
import ProductCategoryLoader from './ProductCategoryLoader';
import ProductsCategory from './ProductsCategory';

interface ProductsCategoryPropsI {
    categories?: {
        categoryListing?: {
            categoryList: SelectComponentProps<SelectCategoryValue>[],
            isFetching: boolean,
            isSuccess: boolean,
            error: {},
        }
        selectedCategory?: string,
    },
    setSelectedCategory: Function,
}

const ProductsCategorySection = (props: ProductsCategoryPropsI) => {
    if (props.categories && props.categories.categoryListing && props.categories.categoryListing.isFetching) {
        return <ProductCategoryLoader />;
    } else {
        return <ProductsCategory
            selectOptions={props.categories && props.categories.categoryListing}
            selectedCategoryId={props.categories && props.categories.selectedCategory}
            setSelectedCategory={props.setSelectedCategory}
        />;
    }
}

function mapStateToProps(state) {
    const { selectedCategory, categoryListing } = state.categories.payload;
    return {
        categories: { categoryListing, selectedCategory },
    }
}

const mapDispatchToProps = {
    setSelectedCategory: CategoryActions.setSelectedCategory
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductsCategorySection);